module.exports = __webpack_public_path__ + "img/viogner.c4013035.jpg";